import styles from "./HintMessage.module.scss";

interface IHintMessageProps {
    /**
    * The text message of the hint.
    */
    hintText: string;
}

/**
 * The hint message.
 * @param {IHintMessageProps} param The props used to render the hint message.
 * @returns The rendered component.
 */
function HintMessage({
    hintText
}: Readonly<IHintMessageProps>): JSX.Element {
    return (
        <div
            className={styles.hint}
            aria-live="polite"
        >
            {hintText}
        </div>
    );
}

export { HintMessage };
